import React from 'react';

function Text({
  children,
  as = "p",
  color = "inherit",
  size = "1rem",
  align = "left",
  // Rename the string-style prop so we don't shadow React's `style`
  fontStyle = "normal",
  weight, // optional prop to set fontWeight directly
  style = {}, // allow the normal React style object
  extraStyles = {}, // additional styles (kept for compatibility)
  ...rest
}) {
  const safeFontStyle = String(fontStyle || "normal").toLowerCase();

  const getFontStyle = () => {
    switch (safeFontStyle) {
      case "bold":
        return { fontWeight: "bold", fontStyle: "normal" };
      case "italic":
        return { fontStyle: "italic", fontWeight: "normal" };
      case "bold-italic":
        return { fontWeight: "bold", fontStyle: "italic" };
      default:
        return { fontWeight: "normal", fontStyle: "normal" };
    }
  };

  const fontStyleObj = getFontStyle();

  // If `weight` prop is provided, it should override the fontWeight derived above
  if (weight) {
    fontStyleObj.fontWeight = weight;
  }

  // Merge order: default props -> computed font styles -> extraStyles -> user `style`
  // Putting user `style` last lets callers override any values (eg. margin, padding)
  const dynamicStyles = {
    color,
    fontSize: size,
    textAlign: align,
    ...fontStyleObj,
    ...extraStyles,
    ...style, // user style wins if there's a conflict
  };

  const Element = as;

  return (
    <Element style={dynamicStyles} {...rest}>
      {children}
    </Element>
  );
}

export default Text;
